import React from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchIncidences } from '../actions/incidences'
import { fetchMachines } from '../actions/machines'
import { fetchCustomers } from '../actions/customers'

import { renderInputField, renderSelectField } from '../utils/forms'

class IncidencesFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false, filterOpen: true }

    this.submit = this.submit.bind(this)
    this.toggleFilter = this.toggleFilter.bind(this)
  }

  componentDidMount() {
    const { fetchMachines, fetchCustomers } = this.props

    fetchMachines()
    fetchCustomers()

    this.load(this.props, true)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props, refresh = false) {
    const { machines, customers, incidences } = props

    if (!incidences.incidences && !incidences.loading && incidences.incidenceNeedRefresh) {
      this.setState({ loaded: false })
      this.submit(this.props.formValues)
    }

    if (!this.state.loaded && machines && customers && incidences) {
      this.setState({ loaded: true })
    }
  }

  toggleFilter() {
    this.setState(prev => ({ filterOpen: !prev.filterOpen }))
  }

  submit(props) {
    return this.props.fetchIncidences(props.Machine, props.Customer, props.Status, props.Category, props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded, filterOpen } = this.state
    const { error, submitting, handleSubmit, machines, customers } = this.props

    if (!loaded) {
      return <LoadingProgress />
    }

    return (
      <div className="inc-admin-filter-card">
        <div className="inc-admin-filter-header" onClick={this.toggleFilter}>
          <h3><i className="fas fa-filter"></i> Filtros</h3>
          <i className={`fas fa-chevron-down toggle-icon ${filterOpen ? 'open' : ''}`}></i>
        </div>
        {filterOpen && (
          <div className="inc-admin-filter-body">
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="filter-grid">
                <div className="filter-group">
                  <Field
                    name="Customer"
                    component={renderSelectField}
                    label="Cliente"
                  >
                    <option value="">Todos</option>
                    {customers &&
                      customers
                        .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                        .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                        .map((customer) => (
                          <option value={customer._id} key={customer._id}>
                            {customer.Fullname}
                          </option>
                        ))}
                  </Field>
                </div>
                <div className="filter-group">
                  <Field name="Machine"
                    component={renderSelectField}
                    label="Máquina">
                    <option value="">Todas</option>
                    {machines.map(machine => (
                      <option value={machine._id} key={machine._id}>
                        {machine.Serial}
                      </option>
                    ))}
                  </Field>
                </div>
                <div className="filter-group">
                  <Field name="Category"
                    component={renderSelectField}
                    label="Categoría">
                    <option value="">Todas</option>
                    <option value="COINS">Pago Monedas</option>
                    <option value="BILLS">Pago Billetes</option>
                    <option value="TPV">Pago Tarjeta</option>
                    <option value="SCREEN_OFF">Pantalla Apagada</option>
                    <option value="SCREEN_BREAK">Pantalla Rota</option>
                    <option value="SCREEN_TOUCH">Táctil No Responde</option>
                    <option value="PRINTER_TICKET">Impresora Ticket</option>
                    <option value="KIOSC_DOOR">Kiosco Puerta</option>
                    <option value="KIOSC_OFF">Kiosco No Enciende</option>
                    <option value="OTHER">Otro</option>
                  </Field>
                </div>
                <div className="filter-group">
                  <Field name="Status"
                    component={renderSelectField}
                    label="Estado">
                    <option value="">Todos</option>
                    <option value="OPEN">Abiertas</option>
                    <option value="IN_REVIEW">En Revisión</option>
                    <option value="IN_REPAIR">En Reparación</option>
                    <option value="RESOLVED">Resueltas</option>
                  </Field>
                </div>
                <div className="filter-group">
                  <Field name="StartDate"
                    component={renderInputField}
                    type="date"
                    label="Fecha inicio" />
                </div>
                <div className="filter-group">
                  <Field name="EndDate"
                    component={renderInputField}
                    type="date"
                    label="Fecha fin" />
                </div>
              </div>
              {error && <div className="alert alert-danger" style={{ marginTop: 12 }}>{error}</div>}
              <button className="inc-admin-filter-submit"
                type="submit"
                disabled={submitting}>
                <i className="fas fa-sync"></i>Actualizar
              </button>
            </form>
          </div>
        )}
      </div>
    )
  }
}

IncidencesFilterForm = reduxForm({
  form: 'IncidencesFilterForm',
  destroyOnUnmount: false
})(IncidencesFilterForm)

const selector = formValueSelector('IncidencesFilterForm')

const mapStateToProps = state => ({
  machines: state.machines.machines,
  incidences: state.incidences,
  customers: state.customers.customers,
  initialValues: {
    Machine: '',
    Customer: '',
    Status: '',
    Category: '',
    StartDate: new Date().toISOString().substring(0, 10),
    EndDate: new Date().toISOString().substring(0, 10)
  },
  formValues: {
    Machine: selector(state, 'Machine'),
    Customer: selector(state, 'Customer'),
    Status: selector(state, 'Status'),
    Category: selector(state, 'Category'),
    StartDate: selector(state, 'StartDate'),
    EndDate: selector(state, 'EndDate')
  }
})

const mapDispatchToProps = dispatch => ({
  fetchIncidences: bindActionCreators(fetchIncidences, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(IncidencesFilterForm)
